import { usePermissions } from '@/viewmodel/features/project/hooks/usePermissions';
import type { PermissionGate } from '@/viewmodel/features/project/types';

export function usePermissionsViewModel(): PermissionGate {
  const { can, isLoading } = usePermissions();

  return { can, isLoading };
}
